export const LOADER_STATUS = 'boilerplate/ITC04/View/LOADER_STATUS';
export const ACTIVE_TAB = 'boilerplate/ITC04/View/ACTIVE_TAB';
export const FILE_DATA = "boilderplate/ITC04/View/FILE_DATA";
export const FILTER_DATA_JW = "boilderplate/ITC04/View/FILTER_DATA_JW";
export const SET_ENTITY_LIST = 'boilderplate/ITC04/SET_ENTITY_LIST';
export const PROFILE_DATA = 'boilderplate/ITC04/PROFILE_DATA';
//---------------------------------------------------------------
export const JWT_GSTIN_DATA = 'boilderplate/ITC04/JWT_GSTIN_DATA';
export const ORG_CHALLAN_DATA = 'boilderplate/ITC04/ORG_CHALLAN_DATA';
export const NEW_CHALLAN_DATA = 'boilderplate/ITC04/NEW_CHALLAN_DATA';
export const INVOICE_DATA = 'boilderplate/ITC04/INVOICE_DATA';
//------------------------------------------------------------------

export const DEFAULT_ENTITY = 'boilderplate/ITC04/DEFAULT_ENTITY';
export const DEFAULT_GSTIN = 'boilderplate/ITC04/DEFAULT_GSTIN';
export const DEFAULT_FREQUENCY = 'boilderplate/ITC04/DEFAULT_FREQUENCY';
export const DEFAULT_SELECT_PERIOD = 'boilderplate/ITC04/DEFAULT_SELECT_PERIOD';

